import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent {

  @Input() titulo!: string;
  @Input() mensaje!: string;
  @Input() success!: boolean;
  @Input() textNextButton: string = 'Aceptar';
  @Input() textBackButton: string = 'Regresar';
  @Input() backButton: boolean = false;

  constructor(public activeModal: NgbActiveModal) { }

  handleNextButton() {
    this.activeModal.close();
  }

  handleBackButton() {
    this.activeModal.dismiss();
  }
}
